import { Box } from "@acko-tech/building-blocks.ui.common";
import styled from "styled-components";

type IDVSectionWrapperProps = {
  styles?: object,
  mStyles?: object
}

export const IDVSectionWrapper = styled(Box) <IDVSectionWrapperProps>`
  ${(props: any) => props.styles}

  @media (max-width: 768px) {
    ${(props: any) => props.mStyles}
  }
`;
